import {MATH_TYPE, PRIMITIVE_MATH_TYPES} from 'common/types/reports/bookmark';

export const SUPPORTED_BEHAVIORAL_AGGREGATIONS: MATH_TYPE[] = [
  PRIMITIVE_MATH_TYPES.TOTAL,
  PRIMITIVE_MATH_TYPES.AVERAGE,
  PRIMITIVE_MATH_TYPES.UNIQUE_VALUES,
  PRIMITIVE_MATH_TYPES.MOST_FREQUENT,
  PRIMITIVE_MATH_TYPES.FIRST_VALUE,
  PRIMITIVE_MATH_TYPES.MAX,
  PRIMITIVE_MATH_TYPES.MIN,
];
